module.exports = __webpack_public_path__ + "static/media/Lesson-9-10-A-Faith-that-Really-Works.92921d49.pdf";